module.exports = __webpack_public_path__ + "img/case5.a713a7cd.jpg";